import { createFileRoute } from '@tanstack/react-router'
import { StaffBooking } from '../../../../components/StaffBooking'

export const Route = createFileRoute('/desa/$slug/dashboard/booking')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffBooking desaId={desaId} />
  },
})
